/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.Indicator.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.ExtCarousel.Indicator.View", ["require", "exports", "Backbone", "sc_ext_carousel_indicator.tpl"], function (require, exports, Backbone_1, indicatorTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ExtCarouselIndicatorView = /** @class */ (function (_super) {
        __extends(ExtCarouselIndicatorView, _super);
        function ExtCarouselIndicatorView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = indicatorTemplate;
            _this.indicatorContentView = options.indicatorContentView;
            _this.setupModelListener();
            return _this;
        }
        ExtCarouselIndicatorView.prototype.setupModelListener = function () {
            var _this = this;
            this.model.slide.on('change:isActive', function () {
                if (_this.model.slide.isActive) {
                    _this.$el.addClass('active');
                }
                else {
                    _this.$el.removeClass('active');
                }
            });
        };
        Object.defineProperty(ExtCarouselIndicatorView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'IndicatorContent.View': function () {
                        return new _this.indicatorContentView({ model: _this.model });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        ExtCarouselIndicatorView.prototype.getContext = function () {
            return {
                index: this.model.index,
                isActive: this.model.slide.isActive,
            };
        };
        return ExtCarouselIndicatorView;
    }(Backbone_1.View));
    exports.ExtCarouselIndicatorView = ExtCarouselIndicatorView;
});
